/*
 * Bouton d'achat epingle, Ruban Paris.
 *
 * LE DEFAUT CORRIGE. Jusqu'au 20 aout, la regle CSS epinglait le bouton des le
 * chargement sous 900px. Il quittait donc le flux et n'apparaissait JAMAIS sous
 * le selecteur d'offre. Mesure : position fixed, bouton a -96px du haut du
 * document a 375px de large, alors qu'a 1440px il etait bien en static juste
 * sous le bundle. Vu de l'exterieur, ca se lit comme un bouton supprime.
 *
 * DESORMAIS. Le bouton reste dans le flux, a sa place sous le selecteur d'offre.
 * Ce script pose la classe rp-atc-fixe sur body a partir du moment ou la
 * premiere section sous la fiche entre dans l'ecran, c'est-a-dire
 * "Pourquoi ce cadeau est si special". C'est la seule chose que fait le script :
 * l'epinglage lui-meme reste en CSS, dans rp-responsive.css.
 *
 * LA CALE. Passer en position fixed sort le bouton du flux : sans compensation,
 * tout ce qui se trouve en dessous remonterait d'un coup de sa hauteur, soit un
 * saut de 70px sous les yeux de la visiteuse. On insere donc une cale vide juste
 * avant le conteneur, a laquelle on donne la hauteur du bouton au moment ou il
 * s'epingle. La hauteur est mesuree AVANT d'ajouter la classe, sinon on
 * mesurerait un element deja sorti du flux.
 *
 * Volontairement un ecouteur de scroll avec verrou, et non un
 * IntersectionObserver : ce theme a deja un historique de moteurs qui n'honorent
 * ni rAF ni le chargement differe (pieges 14 et 27), et un simple test de
 * position est verifiable a la main.
 */
(function () {
  'use strict';

  var CLASSE = 'rp-atc-fixe';
  var mq = window.matchMedia('(max-width: 900px)');

  function init() {
    var btn = document.querySelector('.rp-atc');
    if (!btn) return;
    var boite = btn.closest('.rp-b');
    if (!boite || boite.dataset.rpSticky) return;
    boite.dataset.rpSticky = '1';

    var cale = document.createElement('div');
    cale.className = 'rp-atc-cale';
    cale.setAttribute('aria-hidden', 'true');
    boite.parentNode.insertBefore(cale, boite);

    /*
     * Repere de declenchement : la premiere section sous la fiche produit. Sur le
     * gabarit produit c'est "Pourquoi ce cadeau est si special". Repli sur le
     * conteneur du bouton lui-meme si le gabarit change.
     */
    var repere = document.querySelector('.rp-its') || boite;

    var actif = false, enAttente = false;

    function appliquer() {
      var doit = mq.matches && repere.getBoundingClientRect().top <= window.innerHeight;
      if (doit === actif) return;
      actif = doit;
      if (doit) {
        cale.style.height = boite.offsetHeight + 'px';
        document.body.classList.add(CLASSE);
      } else {
        document.body.classList.remove(CLASSE);
        cale.style.height = '';
      }
    }

    function planifier() {
      if (enAttente) return;
      enAttente = true;
      setTimeout(function () { enAttente = false; appliquer(); }, 80);
    }

    window.addEventListener('scroll', planifier, { passive: true });
    window.addEventListener('resize', planifier);
    if (mq.addEventListener) mq.addEventListener('change', planifier);

    /* Expose pour pouvoir controler l'etat depuis la console, sans defiler. */
    window.rpStickyAtc = { appliquer: appliquer, etat: function () { return actif; } };

    appliquer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* L'editeur de theme re-injecte les sections sans recharger la page. */
  document.addEventListener('shopify:section:load', init);
})();

/*
 * Bandeau de consentement Shopify, 15 septembre. Il est fixe en bas de l'ecran
 * avec un z-index de deux millions : impossible de passer la barre d'achat
 * epinglee devant. On mesure donc sa hauteur tant qu'il est affiche et on
 * l'expose en --rp-consent-h, que rp-responsive.css utilise comme bottom de la
 * barre epinglee. Bandeau accepte ou refuse : il passe en display:none, la
 * variable retombe a 0 et la barre redescend. Le bandeau est ajoute en fin de
 * body par storefront-banner.js, apres ce script : d'ou l'observateur sur body.
 */
(function () {
  'use strict';
  var racine = document.documentElement;
  var enAttente = false;
  var surveille = null;

  function mesurer() {
    var b = document.getElementById('shopify-pc__banner');
    var h = 0;
    if (b && getComputedStyle(b).display !== 'none') h = Math.round(b.getBoundingClientRect().height);
    racine.style.setProperty('--rp-consent-h', h + 'px');
  }
  function planifier() {
    if (enAttente) return;
    enAttente = true;
    setTimeout(function () { enAttente = false; mesurer(); }, 100);
  }
  function brancher() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b || b === surveille) return;
    surveille = b;
    if ('MutationObserver' in window) {
      new MutationObserver(planifier).observe(b, { attributes: true, attributeFilter: ['style', 'class'] });
    }
    if ('ResizeObserver' in window) new ResizeObserver(planifier).observe(b);
  }

  if ('MutationObserver' in window && document.body) {
    new MutationObserver(function () { brancher(); planifier(); }).observe(document.body, { childList: true });
  }
  window.addEventListener('resize', planifier);
  brancher();
  mesurer();
})();
